<template>
    <div class="container-fluid bg-dark px-3 d-none d-lg-block">
        <div class="row gx-0 align-items-center" style="height: 45px;">
            <div class="col-lg-9 text-center text-lg-start mb-lg-0">
                <div class="d-flex align-items-center justify-content-start">
                    <a href="#" class="text-light me-2" style="font-size: medium;"><span class="text-white">THE ONE AND
                            OFFICIALLY NUFREP WEBSITE FOR PUBLISHING DATA AND INFORMATION</span></a>
                </div>
            </div>
            <div class="col-lg-3 text-center text-lg-end">
                <div class="d-flex align-items-center justify-content-end">
                    <a href="#" class="btn nav-fill me-6 text-white" style="font-size: medium;">Bahasa / Language</a>
                    <a href="#" class="btn btn-light btn-square border rounded-circle nav-fill me-3"
                        :class="[((bahasa === null) || (bahasa == 'ina') ? 'btn-pmis' : '')]"
                        @click="gantibahasa('ina')"><img src="../../../../../src/assets/img/ina.jpg" height="20"></a>
                    <a href="#" class="btn btn-light btn-square border rounded-circle nav-fill me-3"
                        :class="[((bahasa == 'eng') ? 'btn-pmis' : '')]" @click="gantibahasa('eng')"><img
                            src="../../../../../src/assets/img/eng.jpg" height="20"></a>
                </div>
            </div>
        </div>
    </div>
    <!-- Topbar End -->
    <div class="container-fluid position-relative p-0">
        <nav class="navbar navbar-expand-lg navbar-light bg-white px-4 px-lg-5 py-3 py-lg-0">
            <a href="/" class="navbar-brand p-0">
                <h5 class="text-danger m-0 pmisdanger gambar2"><img src="../../../../../src/assets/img/nufrepr2.png"
                        height="60"></h5>
                <!-- <img src="img/logo.png" alt="Logo"> -->
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                <span class="fa fa-bars"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <div class="navbar-nav ms-auto py-0">
                    <a href="/"
                        :class="[((route.name == 'Beranda') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">BERANDA</span>
                        <span v-else>HOME</span>
                    </a>
                    <div class="nav-item dropdown">
                        <a href="#" data-bs-toggle="dropdown"
                            :class="[(((route.name == 'DaftarKonten') || (route.name == 'DaftarTimPelaksana')) ? 'nav-link active dropdown-toggle' : 'nav-link dropdown-toggle')]">
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">SEKILAS NUFReP</span>
                            <span v-else>ABOUT NUFReP </span>
                        </a>
                        <div class="dropdown-menu m-0">
                            <a :href="'/DaftarKonten/' + bytes1"
                                :class="[((route.name == 'DaftarKonten' && secretencData == '7') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Informasi NUFReP</span>
                                <span v-else>NUFReP Information </span>
                            </a>
                            <a :href="'/DaftarKonten/' + bytes2"
                                :class="[((route.name == 'DaftarKonten' && secretencData == '8') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Unit Kerja / Balai / PIU</span>
                                <span v-else>Implementing Unit</span>
                            </a>
                            <a :href="'/DaftarTimPelaksana'"
                                :class="[((route.name == 'DaftarTimPelaksana') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Tim PMC NUFReP</span>
                                <span v-else>NUFReP PMC Team</span>
                            </a>
                        </div>
                    </div>
                    <a href="/DaftarAgenda"
                        :class="[((route.name == 'DaftarAgenda') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">KALENDER ACARA</span>
                        <span v-else>EVENT CALENDAR</span>
                    </a>
                    <div class="nav-item dropdown">
                        <a href="#" data-bs-toggle="dropdown"
                            :class="[(((route.name == 'DaftarStatus') || (route.name == 'DaftarProgramBudgeting')
                                || (route.name == 'DaftarFinance') || (route.name == 'DaftarMonev') || (route.name == 'DaftarPDOIOS')
                                || (route.name == 'DaftarQuickStatus')) ? 'nav-link active dropdown-toggle' : 'nav-link dropdown-toggle')]">
                            MONITORING
                        </a>
                        <div class="dropdown-menu m-0">
                            <a :href="'/DaftarStatus'" v-if="QuickStatusProyek == 1"
                                :class="[((route.name == 'DaftarStatus') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Quick Status Proyek</span>
                                <span v-else>Quick Project Status</span>
                            </a>
                            <a :href="'/DaftarProgramBudgeting'" v-if="ProgramBudgeting == 1"
                                :class="[((route.name == 'DaftarProgramBudgeting') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Program & Budgeting</span>
                                <span v-else>Program & Budgeting</span>
                            </a>
                            <a :href="'/DaftarFinance'"  v-if="Finance == 1"
                                :class="[((route.name == 'DaftarFinance') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Keuangan</span>
                                <span v-else>Finance</span>
                            </a>
                            <a :href="'/DaftarMonev'"  v-if="ProgresKegiatanProyek == 1"
                                :class="[((route.name == 'DaftarMonev') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Progres Kegiatan Proyek</span>
                                <span v-else> Progress Of Project </span>
                            </a>
                            <a :href="'/DaftarPDOIOS'"  v-if="KeyPerformanceIndicator == 1"
                                :class="[((route.name == 'DaftarPDOIOS') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Key Performance Indicator</span>
                                <span v-else>Key Performance Indicator</span>
                            </a>
                            <a :href="'/DaftarQuickStatus'"  v-if="StatusPengadaan == 1"
                                :class="[((route.name == 'DaftarQuickStatus') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Status Pengadaan</span>
                                <span v-else>Procurement Status</span>
                            </a>
                        </div>
                    </div>
                    <div class="nav-item dropdown">
                        <a href="#" data-bs-toggle="dropdown"
                            :class="[(((route.name == 'Aduan') || (route.name == 'CariAduan')
                                || (route.name == 'DaftarAduan')) ? 'nav-link active dropdown-toggle' : 'nav-link dropdown-toggle')]">
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">LAYANAN ADUAN</span>
                            <span v-else>COMPLAINT SERVICES</span>
                        </a>
                        <div class="dropdown-menu m-0">
                            <a :href="'/Aduan'"
                                :class="[((route.name == 'Aduan') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Input Layanan Aduan</span>
                                <span v-else>Complains Services Input</span>
                            </a>
                            <a :href="'/CariAduan'"
                                :class="[((route.name == 'CariAduan') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Cari Pengaduan</span>
                                <span v-else>Find Complains</span>
                            </a>
                            <a :href="'/DaftarAduan'"
                                :class="[((route.name == 'DaftarAduan') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Monitoring Pengaduan</span>
                                <span v-else>Complains Monitoring</span>
                            </a>
                        </div>
                    </div>
                    <a :href="'/GIS/' + bytes"
                        :class="[((route.name == 'GIS') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">PETA</span>
                        <span v-else>MAPS</span>
                    </a>
                    <a href="/DaftarBerita"
                        :class="[((route.name == 'DaftarBerita') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">BERITA</span>
                        <span v-else>NEWS</span>
                    </a>
                    <a href="/DaftarAlbumDokumen" style="display: none;"
                        :class="[((route.name == 'DaftarAlbumDokumen' || route.name == 'DaftarGaleriDokumen') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">DOKUMEN</span>
                        <span v-else>DOCUMENTS</span>
                    </a>
                    <a href="/DaftarAlbumDocumen"
                        :class="[((route.name == 'DaftarAlbumDocumen' || route.name == 'DaftarGaleriDokumen') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">DOKUMEN</span>
                        <span v-else>DOCUMENTS</span>
                    </a>
                    <a href="/DaftarAlbum"
                        :class="[((route.name == 'DaftarAlbum' || route.name == 'DaftarGaleri') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">GALERI</span>
                        <span v-else>GALLERY</span>
                    </a>
                    <div class="nav-item dropdown">
                        <a href="#" data-bs-toggle="dropdown"
                            :class="[(((route.name == 'KontakKami') || (route.name == 'FAQ') || (route.name == 'MasukanSaran')) ? 'nav-link active dropdown-toggle' : 'nav-link dropdown-toggle')]">
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">TENTANG KAMI</span>
                            <span v-else>ABOUT US</span>
                        </a>
                        <div class="dropdown-menu m-0">
                            <a :href="'/KontakKami'"
                                :class="[((route.name == 'KontakKami') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')"> Kontak Kami</span>
                                <span v-else>Contact Us</span>
                            </a>
                            <a :href="'/FAQ'"
                                :class="[((route.name == 'FAQ') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">FAQ</span>
                                <span v-else>FAQ</span>
                            </a>
                            <a :href="'/MasukanSaran'"
                                :class="[((route.name == 'MasukanSaran') ? 'dropdown-item active' : 'dropdown-item')]">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Saran Dan Masukan</span>
                                <span v-else>Suggestions and Feedback</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import Finance from '../../Backoffice/Finance/Finance.vue';

export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        swal
    },
    data() {
        return {
            tabaktif: encodeURIComponent(CryptoJS.AES.encrypt('', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            bytes: encodeURIComponent(CryptoJS.AES.encrypt('Kosong', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            bytes1: encodeURIComponent(CryptoJS.AES.encrypt('7', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            bytes2: encodeURIComponent(CryptoJS.AES.encrypt('8', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            bytes3: encodeURIComponent(CryptoJS.AES.encrypt('9', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            QuickStatusProyek: 1,
            ProgramBudgeting: 1,
            Keuangan: 1,
            ProgresKegiatanProyek: 1,
            KeyPerformanceIndicator: 1,
            StatusPengadaan: 1,
            secretencData: '',
            datapesan: '',
            master: '',
        };
    },
    methods: {
        gantibahasa(bahasanya) {
            localStorage.setItem("bahasasistem", bahasanya);
            location.reload();
        },
        async ambildata() {
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmenu-GetMenu?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.master = Response.data.content.data;
                    }
                    this.master.forEach((item) => {
                        if (item.id == 1) {
                            if (item.tampil == 0) {
                                this.QuickStatusProyek = 0;
                            }
                        }
                        if (item.id == 2) {
                            if (item.tampil == 0) {
                                this.ProgramBudgeting = 0;
                            }
                        }
                        if (item.id == 3) {
                            if (item.tampil == 0) {
                                this.Keuangan = 0;
                            }
                        }
                        if (item.id == 4) {
                            if (item.tampil == 0) {
                                this.ProgresKegiatanProyek = 0;
                            }
                        }
                        if (item.id == 5) {
                            if (item.tampil == 0) {
                                this.KeyPerformanceIndicator = 0;
                            }
                        }
                        if (item.id == 6) {
                            if (item.tampil == 0) {
                                this.StatusPengadaan = 0;
                            }
                        }
                    });
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });
        },
    },
    mounted() {
        try {
            this.secretencData = decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8));
        } catch (error) {
        }
        this.ambildata();
    },
}
</script>

<style></style>